import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { ChevronArrowLeftIcon } from '../../assets/icons/ChevronArrowLeftIcon';
import { ChevronArrowRightIcon } from '../../assets/icons/ChevronArrowRightIcon';
import { ThreeDotsLoader } from '../../assets/icons/ThreeDotsLoader';
import { getMergedClassNames } from '../../utils/HTMLutils';
import IconButton from '../iconButton/IconButton';
import './Paginator.scss';
const rootClassName = 'component-paginator';

interface PaginatorProps {
  id?: string;
  className?: string;
  quantidadeDePaginas: number;
  paginaAtual: number;
  onChange: (event: any) => void;
  maxLength?: number;
  loading?: boolean;
}

export default function Paginator(props: PaginatorProps) {
  // const quantidadeDePaginas = Math.ceil(
  //   (1.0 * parseInt(props.total)) / parseInt(props.limiter)
  // )

  // const paginaAtual = Math.ceil(
  //   (1.0 * parseInt(props.firstIndex === 0 ? 1 : props.firstIndex + 1)) /
  //     parseInt(props.limiter)
  // )

  const [arrOfNumbers, setArrOfNumbers] = useState<number[]>([]);
  useEffect(() => {
    const arr = [];
    let inicio = 1;
    let fim = props.quantidadeDePaginas;

    if (props.maxLength) {
      const maxLength =
        props.maxLength > props.quantidadeDePaginas
          ? props.quantidadeDePaginas
          : props.maxLength;
      inicio = Math.round(props.paginaAtual - maxLength / 2);
      inicio = Math.max(inicio, 1);
      fim = inicio + maxLength - 1;
      if (fim > props.quantidadeDePaginas) {
        fim = props.quantidadeDePaginas;
        inicio = fim - maxLength + 1;
      }
    }

    for (let i = inicio; i <= fim; i++) {
      arr.push(i);
    }
    setArrOfNumbers(arr);
  }, [props.quantidadeDePaginas, props.maxLength, props.paginaAtual]);

  return (
    <div
      id={props.id ? props.id : undefined}
      className={getMergedClassNames([rootClassName, props.className || ''])}
    >
      <div className={`${rootClassName}-center-content`}>
        <div className={props.loading ? `hidden` : ''}>
          {props.quantidadeDePaginas > 1 ? (
            <div className={`${rootClassName}-left-arrow`}>
              <IconButton
                disabled={props.paginaAtual === 1}
                icon={<ChevronArrowLeftIcon />}
                onClick={() => {
                  if (typeof props.onChange === 'function') {
                    props.onChange(props.paginaAtual - 1);
                  }
                }}
              />
            </div>
          ) : undefined}
          <div className={`${rootClassName}-numbers`}>
            {arrOfNumbers.map((num) => {
              return (
                <button
                  key={num}
                  className={getMergedClassNames([
                    `${rootClassName}-number`,
                    num === props.paginaAtual ? 'active' : '',
                  ])}
                  onClick={() => {
                    if (
                      typeof props.onChange === 'function' &&
                      num !== props.paginaAtual
                    ) {
                      props.onChange(num);
                    }
                  }}
                >
                  {num}
                </button>
              );
            })}
          </div>
          {props.quantidadeDePaginas > 1 ? (
            <div className={`${rootClassName}-right-arrow`}>
              <IconButton
                icon={<ChevronArrowRightIcon />}
                onClick={() => {
                  if (typeof props.onChange === 'function') {
                    props.onChange(props.paginaAtual + 1);
                  }
                }}
                disabled={props.paginaAtual >= props.quantidadeDePaginas}
              />
            </div>
          ) : undefined}
        </div>
        <CSSTransition
          classNames={`${rootClassName}-loader`}
          in={props.loading}
          timeout={300}
          unmountOnExit
        >
          <div className={`${rootClassName}-loader`}>
            <ThreeDotsLoader size={2} />
          </div>
        </CSSTransition>
      </div>
    </div>
  );
}

Paginator.defaultProps = {};
